"use client";
import { MouseEvent } from "react";
import { stopVideo } from "./stop-video";

export const onVideoMouseLeave = (e: MouseEvent<HTMLVideoElement>) => {
  const target = e.currentTarget;
  stopVideo(target);
};
